import { render, staticRenderFns } from "./ShowProblemsModal.vue?vue&type=template&id=04a39e56&scoped=true&"
import script from "./ShowProblemsModal.vue?vue&type=script&lang=js&"
export * from "./ShowProblemsModal.vue?vue&type=script&lang=js&"
import style0 from "./ShowProblemsModal.vue?vue&type=style&index=0&id=04a39e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a39e56",
  null
  
)

export default component.exports